import { getTokenValue } from '../user';

export const getAuthorizationHeader = (tokenValue?: string) => {
  const resultTokenValue = tokenValue || getTokenValue();

  return resultTokenValue ? `Bearer ${resultTokenValue}` : '';
};
